<template>
  <div
    id="rncpImportModal"
    ref="rncpImportModal"
    aria-hidden="true"
    aria-labelledby="rncpImportModal"
    class="modal fade"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title textStyle">
            <FontAwesomeIcon icon="fa-light fa-warning" />
            {{ $t("training.rncp.actions.reimporting_skills") }}
          </h5>
          <button
            aria-label="Close"
            class="btn-close"
            data-bs-dismiss="modal"
            data-dismiss="modal"
            type="button"
          ></button>
        </div>
        <div class="modal-body">
          <p>{{ $t("training.rncp.modal.text") }}</p>
          <ButtonRadioTypeComponent
            :title="$t('training.rncp.modal.merge_button_title')"
            :selectedValue="selected"
            :subTitle="$t('training.rncp.modal.merge_button_text')"
            value="merge"
            @selected="select"
          />

          <ButtonRadioTypeComponent
            :title="$t('training.rncp.modal.crush_button_title')"
            :selectedValue="selected"
            :subTitle="$t('training.rncp.modal.crush_button_text')"
            value="crush"
            @selected="select"
          />

          <AlertBlock
            icon="warning"
            :text="$t('training.rncp.modal.alert_text')"
            :title="$t('training.rncp.modal.alert_title')"
            type="warning"
          />

          <SubmitTypeComponent :submitText="$t('training.rncp.modal.submit')" @submitForm="submit" @cancelForm="hide" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import AlertBlock from "@/components/blocks/AlertBlock.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import SubmitTypeComponent from "@/components/form/SubmitTypeComponent.vue";
import ButtonRadioTypeComponent from "@/components/form/ButtonRadioTypeComponent.vue";

export default {
  name: "TrainingRncpImportModalComponent",
  components: { ButtonRadioTypeComponent, SubmitTypeComponent, FontAwesomeIcon, AlertBlock },
  emits: ["import", "hidden"],
  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },
  computed: {},
  data() {
    return {
      selected: "merge",
    };
  },
  watch: {
    open() {
      if (this.open) {
        this.openModal();
      }
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.$refs.rncpImportModal) {
        this.$refs.rncpImportModal.addEventListener("hidden.bs.modal", this.hidden);
      }
    },

    openModal() {
      this.selected = "merge";
      if (this.$refs.rncpImportModal) {
        const modal = new Modal(this.$refs.rncpImportModal);
        modal.show();
      }
    },

    hide() {
      if (this.$refs.rncpImportModal) {
        const modal = Modal.getOrCreateInstance(this.$refs.rncpImportModal);
        modal.hide();
        this.hidden();
      }
    },

    select(value) {
      this.selected = value;
    },

    submit() {
      this.$emit("import", this.selected);
      this.hide();
    },

    hidden() {
      this.$emit("hidden");
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-content {
  .modal-header {
    svg {
      color: var(--primary-color) !important;
    }
  }
}
</style>
